import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import telIcon from '../../theme/assets/svg/ftf_soc_tel_icon.svg';
import disIcon from '../../theme/assets/svg/ftf_soc_dis_icon.svg';
import xIcon from '../../theme/assets/svg/ftf_soc_twit_icon.svg';
import instIcon from '../../theme/assets/svg/ftf_soc_inst_icon.svg';
import redIcon from '../../theme/assets/svg/ftf_soc_red_icon.svg';

import heroArt from '../../theme/assets/redesign/hero.webp';
import mascot from '../../theme/assets/redesign/mascot.webp';


const SOCIALS = [
    {href: 'https://t.me/+g3JnDISU5AkyNGIy', icon: telIcon, label: 'Telegram'},
    {href: 'https://discord.gg/E5GN3zFc', icon: disIcon, label: 'Discord'},
    {href: 'https://x.com/Fuckthefomo', icon: xIcon, label: 'X'},
    {href: 'https://www.instagram.com/fckthefomo/?hl=ru', icon: instIcon, label: 'Instagram'},
    {href: 'https://www.reddit.com/user/WonderOk6012/', icon: redIcon, label: 'Reddit'},
];

// Заглушка для пользователей без доступа (allowed !== true), в стиле нового кабинета
const ComingSoon = () => {
    const {t} = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={Styles.bg}/>
            <div className={Styles.card}>
                <div className={Styles.art}><img src={heroArt} alt=""/></div>
                <img className={Styles.mascot} src={mascot} alt=""/>
                <div className={Styles.title}>{t('Спасибо за регистрацию')}!</div>
                <div className={Styles.notes}>
                    <p>{t('Доступ к платформе будет доступен в скором времени, информация об этом будет отправлена на указанную вами электронную почту')}.</p>
                    <p>{t('Подписывайтесь на наши социальные сети, чтобы ничего не пропустить')}!</p>
                </div>
                <div className={Styles.socials}>
                    {SOCIALS.map(s => (
                        <a key={s.label} className={Styles.social} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                            <img src={s.icon} alt={s.label}/>
                        </a>
                    ))}
                </div>
                <div className={Styles.soon}>Coming soon...</div>
            </div>
        </section>
    );
};

export default ComingSoon;
